import { useSelectContext } from "@molecules/Select/Select.context"

import { SelectErrorProps } from "./SelectError.types"

export default function SelectError(props: SelectErrorProps) {
    const { children } = props
    const { searchData } = useSelectContext()

    if (!searchData?.isError) {
        return null
    } else {
        return <>{children}</>
    }
}
